var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPieChartWidget = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 50,
  height: 50,
  viewBox: "0 0 50 50"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  "data-name": "pie chart icon",
  className: "pie_chart_widget_svg__cls-1",
  d: "M49 24H26V0a24 24 0 0 1 24 24h-1ZM28 2.095V22h19.908A22 22 0 0 0 28 2.095ZM46 26h2A24 24 0 1 1 24 2v24h22Zm-22 2h-2V4.095A22 22 0 1 0 45.905 28H24Z"
})));
SvgPieChartWidget.displayName = "SvgPieChartWidget";
export { SvgPieChartWidget as ReactComponent };
export default SvgPieChartWidget;